import { render, staticRenderFns } from "./cadastro_debito.vue?vue&type=template&id=d38aa238"
import script from "./cadastro_debito.vue?vue&type=script&lang=js"
export * from "./cadastro_debito.vue?vue&type=script&lang=js"
import style0 from "./cadastro_debito.vue?vue&type=style&index=0&id=d38aa238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports